import Swiper from '../../common/custom-swiper/custom-swiper';

export default new class costOfServiceSlider {
  constructor() {
    this.sliderWrapperSelector = 'cost-of-services-slider__wrapper';
    this.sliderContainerSelector = 'cost-of-services-slider__container';
    this.slideSelector = 'cost-of-services-slider__item';

    this.handler();
  }

  handler() {
    const sliders = document.querySelectorAll(`.${this.sliderWrapperSelector}`);

    if (!sliders) return;

    document.addEventListener('DOMContentLoaded', () => {
      const swipers = document.querySelectorAll(`.${this.sliderWrapperSelector}`);

      swipers.forEach((swiper) => {
        this.init(swiper);
      });
    });
  }

  init(slider) {
    this.blogSlider = new Swiper(slider.querySelector(`.${this.sliderContainerSelector}`), {
      slidesPerView: 1.2,
      spaceBetween: 15,
      breakpointsInverse: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      navigation: {
        nextEl: slider.querySelector('.cost-of-services-slider__nav_next'),
        prevEl: slider.querySelector('.cost-of-services-slider__nav_prev'),
        disabledClass: 'cost-of-services-slider__nav_disable',
        hiddenClass: 'cost-of-services-slider__nav_hidden',
      },
      breakpoints: {
        769: {
          slidesPerView: 2.5,
          spaceBetween: 25,
        },
        920: {
          slidesPerView: 3,
          spaceBetween: 28,
        },
      },
    });
  }
}();
